/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailBranding
 */
export interface EmailBranding {
    /**
     * 
     * @type {string}
     * @memberof EmailBranding
     */
    privacyUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailBranding
     */
    postalAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailBranding
     */
    siteDisplayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailBranding
     */
    siteUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailBranding
     */
    heroIconUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailBranding
     */
    heroImageUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailBranding
     */
    brandColor?: string | null;
}

/**
 * Check if a given object implements the EmailBranding interface.
 */
export function instanceOfEmailBranding(value: object): value is EmailBranding {
    return true;
}

export function EmailBrandingFromJSON(json: any): EmailBranding {
    return EmailBrandingFromJSONTyped(json, false);
}

export function EmailBrandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailBranding {
    if (json == null) {
        return json;
    }
    return {
        
        'privacyUrl': json['privacyUrl'] == null ? undefined : json['privacyUrl'],
        'postalAddress': json['postalAddress'] == null ? undefined : json['postalAddress'],
        'siteDisplayName': json['siteDisplayName'] == null ? undefined : json['siteDisplayName'],
        'siteUrl': json['siteUrl'] == null ? undefined : json['siteUrl'],
        'heroIconUrl': json['heroIconUrl'] == null ? undefined : json['heroIconUrl'],
        'heroImageUrl': json['heroImageUrl'] == null ? undefined : json['heroImageUrl'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
    };
}

export function EmailBrandingToJSON(value?: EmailBranding | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'privacyUrl': value['privacyUrl'],
        'postalAddress': value['postalAddress'],
        'siteDisplayName': value['siteDisplayName'],
        'siteUrl': value['siteUrl'],
        'heroIconUrl': value['heroIconUrl'],
        'heroImageUrl': value['heroImageUrl'],
        'brandColor': value['brandColor'],
    };
}

